import { SkeletonRows } from '@/components/ui'
import { Shell } from '@/features/shell/Shell'
import { useConsoleStore } from '@/store/consoleStore'
import { Suspense, lazy } from 'react'
import { Navigate, Outlet, createBrowserRouter, useLocation } from 'react-router'

const LoginPage = lazy(() => import('@/features/auth/LoginPage'))
const ChangePasswordPage = lazy(() => import('@/features/auth/ChangePasswordPage'))
const AttendanceGridPage = lazy(() => import('@/features/attendance/AttendanceGridPage'))
const MembersPage = lazy(() => import('@/features/members/MembersPage'))
const AccountsPage = lazy(() => import('@/features/users/AccountsPage'))
const SettingsPage = lazy(() => import('@/features/settings/SettingsPage'))

function Guard() {
  const status = useConsoleStore((s) => s.status)
  const mustChange = useConsoleStore((s) => s.user?.mustChangePassword ?? false)
  const { pathname } = useLocation()
  if (status === 'signedOut' && pathname !== '/login') return <Navigate to="/login" replace />
  if (status === 'signedIn') {
    if (mustChange && pathname !== '/change-password')
      return <Navigate to="/change-password" replace />
    if (!mustChange && (pathname === '/login' || pathname === '/change-password')) {
      return <Navigate to="/attendance" replace />
    }
  }
  return (
    <Suspense
      fallback={
        <div style={{ padding: 'var(--sp-xxl)' }}>
          <SkeletonRows />
        </div>
      }
    >
      <Outlet />
    </Suspense>
  )
}

export const router = createBrowserRouter([
  {
    element: <Guard />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/change-password', element: <ChangePasswordPage /> },
      {
        element: <Shell />,
        children: [
          { path: '/attendance', element: <AttendanceGridPage /> },
          { path: '/members', element: <MembersPage /> },
          { path: '/accounts', element: <AccountsPage /> },
          { path: '/settings', element: <SettingsPage /> },
        ],
      },
      { path: '*', element: <Navigate to="/attendance" replace /> },
    ],
  },
])
